import { dew as _GetUserMediaErrorDew } from "./GetUserMediaError";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  // SPDX-License-Identifier: Apache-2.0
  var __importDefault = exports && exports.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  const GetUserMediaError_1 = __importDefault(_GetUserMediaErrorDew());
  class TypeError extends GetUserMediaError_1.default {
    constructor(cause) {
      super(cause);
      this.name = "TypeError";
    }
  }
  exports.default = TypeError;
  //# sourceMappingURL=TypeError.js.map
  return exports;
}